import { Colors, Fonts } from '../../../shared/theme/';
import metrics from '../../../shared/theme/metrics';

export default {
  defaultContent: {
    minHeight: '100vh',
    paddingTop: '72px',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'column',
    display: 'flex',
  } as React.CSSProperties,
  cardBox: {
    marginTop: '24px',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'row'
  } as React.CSSProperties,
  cardSuccess: {
    marginRight: '10px',
    marginLeft: '10px',
  } as React.CSSProperties,
  cardCover: {
    padding: 16,
    width: '136px',
    height: '100%',
    borderRadius: '4px',
    border: 'none'
  },
  cardBody: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    padding: 0,
    paddingTop: 16
  },
  titleBox: {
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  imageBox: {
    width: '100%',
    height: 104
  },
  buttonBox: {
    marginTop: '56px',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    width: '300px'
  },
  titleContent: {
    ...Fonts.style.textHeaderKanitRegular14,
    color: Colors.font.primary.fakeBlack,
    // whiteSpace: 'nowrap'
    textAlign: 'center'
  },
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column'
  },
  martImage: {
    width: '800px',
    marginTop: metrics.baseMargin * 2.5
  }
};
